import cn from "classnames";
import s from "./Divider.module.scss";

const Divider = ({ className, height = "6px", absolute, vertical }) => {
  const classes = cn(
    className,
    s.divider,
    absolute && s.absolute,
    vertical && s.vertical
  );
  return (
    <div
      className={classes}
      style={{
        ...(!vertical && height
          ? {
              height,
            }
          : {}),
        ...(vertical && height
          ? {
              width: height,
            }
          : {}),
      }}
    >
      <div className={s.part} />
      <div className={s.part} />
    </div>
  );
};

export default Divider;
